import { useState } from "react";
import SchoolBillingContactsModal from "../../components/modals/School.Billing.Contacts";
import SchoolSenderId from "../../components/modals/School.Sender.Id";
import SubscriptionReceiptModal from "../../components/modals/Subscription.Receipt";
import SchoolSubscriptionModal from "../../components/modals/Subscriptions";

import { Button, Pagination, Input, List, Skeleton, Modal, Divider } from 'antd';
import moment from 'moment';
import { Link } from "react-router-dom";


const BackOfficeSchools = ({ setSearchString, deleteSchool, schools, loading, refresh, currentPage, setCurrentPage, pageSize, extractTokenFromUrl , getMonthsBackwards }) => {
  
  const [ openSubscriptionModal , setOpenSubscriptionModal ] = useState(false);
  const [ openSchoolSmsSenderIdModal , setOpenSchoolSmsSenderIdModal ] = useState(false);
  const [ school , setSchool ] = useState({});
  const [ openDownloadInvoiceModal, setOpenDownloadInvoiceModal ] = useState(false)
  const [ openBillingContactModal, setOpenBillingContactModal ] = useState(false)

  return <>
  <div
    style={{
      display: "flex",
      justifyContent: "center", // centers horizontally
      alignItems: "center", // centers vertically
      gap: 10, // space between title and input
      marginBottom: 10,
      justifyContent: "space-between",
    }}
  >
    <h3 style={{ fontSize: 13, margin: 0 }}>Schools ({schools?.totalSchools || 0 })</h3>
    <Input
      style={{ height: 29, width: 220 }}
      placeholder="Search School"
      onChange={(e) => {
        setSearchString(e.target.value);
        setCurrentPage(1);
      }}
    />
  </div>

  <Divider />

  <List
    dataSource={schools.schools || []}
    loading={loading}
    renderItem={(item) => (
      <List.Item
        actions={[
          <a key="list-loadmore-edit" style={{ fontSize: 11.5 }}>
            {item.subscriptionCurrency?.name} {parseFloat(item?.revenue).toFixed(2)}
          </a>,
        ]}
        style={{ fontSize: 13 }}
      >
        <Skeleton avatar title={false} loading={item?.loading} active>
          <List.Item.Meta
            title={
              <Link to={`school-invoices?token=${extractTokenFromUrl()}&id=${item.id}`} style={{ textDecoration : "none"}}>
                {item?.name} - {moment(item?.date).fromNow()}
              </Link>
            }
            description={
              <div style={{ color: "#888" }}>
                  <div style={{ fontSize: 12, display : "flex", gap : 10 }}>
                    <div>
                      <span style={{ fontWeight : 600 }}>Subscription:{" "}</span>
                      <span>{item.subscriptionCurrency?.name} {item?.subscriptionAmount}</span>
                    </div>
                    <div>
                      <span style={{ fontWeight : 600 }}>Students:{" "}</span>
                      <span>{item.students}</span>
                    </div>
                    <div>
                      <span style={{ fontWeight : 600 }}>Econet:{" "}</span>
                      <span>{item.totalEconetSms}</span>
                      (<span style={{ color : "red"}}>{item.totalFailedEconetSms}</span>)
                    </div>
                    <div>
                      <span style={{ fontWeight : 600 }}>NetOne:{" "}</span>
                      <span>{item.totalNetOneSms}</span>
                      (<span  style={{ color : "red"}}>{item.totalFailedNetOneSms}</span>)
                    </div>
                    
                  </div>

                <div style={{ marginTop: "0.6rem" }}>
                  <Link to={`school-invoices?token=${extractTokenFromUrl()}&id=${item.id}`} style={{ textDecoration: "none" }}>
                  <Button
                    size="small"
                    type="link"
                    onClick={()=>{
                      setOpenDownloadInvoiceModal(true);
                      setSchool(item);
                    }} 
                  >
                    <span style={{ fontSize: 11 }}> Invoices </span>
                  </Button>
                  </Link>

                  <Button
                    size="small"
                    type="link"
                    onClick={()=>{
                      setOpenBillingContactModal(true);
                      setSchool(item);
                    }} 
                    style={{ color : "purple"}}
                  >
                    <span style={{ fontSize: 11 }}> Contacts </span>
                  </Button>

                  <Button
                    size="small"
                    type="link"
                      onClick={ ()=>{
                          setOpenSubscriptionModal(true);
                          setSchool(item)
                      }}
                      style={{ color : "green"}}
                  >
                    <span style={{ fontSize: 11 }}> Subscriptions </span>
                  </Button>

                  <Button
                    size="small"
                    type="link"
                      onClick={ ()=>{
                          setOpenSchoolSmsSenderIdModal(true);
                          setSchool(item)
                      }}
                      style={{ color : "#050505"}}
                  >
                    <span style={{ fontSize: 11 }}> Settings </span>
                  </Button>

                  <Button
                    size="small"
                    type="link"
                    onClick={() => {
                      Modal.confirm({
                        title: "Are you sure you want to delete this?",
                        onCancel: () => {},
                        onOk: () => deleteSchool(item?.id),
                      });
                    }}
                    danger
                  >
                    <span style={{ fontSize: 11 }}>Delete</span>
                  </Button>
                </div>
              </div>
            }
          />
        </Skeleton>
      </List.Item>
    )}
  />

  {/* Pagination */}
  {schools?.totalSchools > pageSize && (
    <div style={{ textAlign: "right", marginTop: "1rem" }}>
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={schools?.totalSchools}
        onChange={(page) => setCurrentPage(page)}
        size="small"
      />
    </div>
  )}


      <div style={{ paddingLeft : "1rem", paddingRight : "1rem"}}>

        <SchoolSenderId
            show={openSchoolSmsSenderIdModal}
            setOpenModal={setOpenSchoolSmsSenderIdModal}
            record={school}
            refresh = {refresh}
        />

        <SchoolSubscriptionModal
            show={openSubscriptionModal}
            setOpenModal={setOpenSubscriptionModal}
            record={school}
            refresh = {refresh}
        />

        <SubscriptionReceiptModal
            show={openDownloadInvoiceModal}
            setOpenModal={setOpenDownloadInvoiceModal}
            record={school}
            getMonthsBackwards={getMonthsBackwards}
            extractTokenFromUrl={extractTokenFromUrl}
        />
        <SchoolBillingContactsModal
            show={openBillingContactModal}
            setOpenModal={setOpenBillingContactModal}
            record={school}
            extractTokenFromUrl={extractTokenFromUrl}
        />
      </div>
      
  </>
}

export default BackOfficeSchools;